// src/utils/scoring.js

export const formatDuration = (startTime) => {
  if (!startTime) return "00:00:00";
  const diff = Date.now() - startTime;
  const h = Math.floor(diff / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);
  return `${h.toString().padStart(2,'0')}:${m.toString().padStart(2,'0')}:${s.toString().padStart(2,'0')}`;
};

export const getDistanceFromLatLonInM = (lat1, lon1, lat2, lon2) => {
  const R = 6371; 
  const dLat = (lat2 - lat1) * (Math.PI / 180);
  const dLon = (lon2 - lon1) * (Math.PI / 180);
  const a = 
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c; 
  return d * 1000; 
};

export const getWeekId = () => {
    const d = new Date();
    // TUESDAY RESET LOGIC:
    // We subtract 1 day from the current date. 
    // This makes "Real Tuesday" behave like "Virtual Monday" (Start of Week)
    // and "Real Monday" behave like "Virtual Sunday" (End of Week).
    d.setDate(d.getDate() - 1);
    
    d.setHours(0,0,0,0);
    d.setDate(d.getDate() + 4 - (d.getDay()||7));
    const yearStart = new Date(d.getFullYear(),0,1);
    const weekNo = Math.ceil(( ( (d - yearStart) / 86400000) + 1)/7);
    return `${d.getFullYear()}-W${weekNo}`;
};

export const calculateSmartScore = (stats) => {
  // ⚠️ App Review guideline 1.4.3: drinks must NEVER earn points. The original
  // formula awarded 50 pts/drink, which made every leaderboard a drinking
  // contest and got 1.1.2 rejected for "encouraging excessive consumption".
  // The score now rewards what the brand actually preaches — keep moving,
  // drink water, pace yourself — and unbalanced drinking only ever COSTS.

  // 1. Movement: the night lived. ~1 pt per 20 steps, capped at 500 (~10k steps).
  const stepScore = Math.min(500, Math.floor((stats.steps || 0) / 20));

  // 2. Water Score: Diminishing Returns
  // Waters 1-5: 25pts | 6+: 5pts
  let waterScore = 0;
  const w = stats.waters || 0;
  if (w <= 5) waterScore = w * 25;
  else waterScore = (5 * 25) + ((w - 5) * 5);

  // 3. Pacing bonus: kept the 1-water-per-5-drinks ratio all night.
  const d = stats.drinks || 0;
  const pacedBonus = d > 0 && (w * 5) >= d ? 100 : 0;

  // 4. The Hangover Penalty (1 Water protects 5 Drinks)
  // Every drink NOT covered by the water ratio costs points.
  const uncoveredDrinks = Math.max(0, d - (w * 5));
  const penalty = uncoveredDrinks * 25;

  return Math.max(0, stepScore + waterScore + pacedBonus - penalty);
};
